import React from "react";
import api from "../../Api/apiAxios";
import { Button, Table } from "react-bootstrap";
import { CardText } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import HeaderContratos from "../../Components/HeaderContratos";
import Loading from "../../Components/Loading";
import { MyContext } from "../../Context/MyContext";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip'
import { Paginacao } from "../../Components/Paginacao";
import styles from "./ContratosIndex.module.css";
import { TableItemName } from "../../Components/TableItemName";
import { PedidosContext } from "../../Context/PedidosContext";
import Mensagem from "../../Components/Mensagem";

const ContratosIndex = () => {

    const navigate = useNavigate();

    const nivelUsuario = window.localStorage.getItem('nivelUsuario');  
    const idDistribuidor = window.localStorage.getItem('distribuidorId');   

    const { listaGlobalContratos, setListaGlobalContratos, itensPorPagina, tipoPesquisaContratos, handleTipoPesquisaContratosChange } = React.useContext(MyContext);
    const { verificarECancelarContratos } = React.useContext(PedidosContext);

    const [pesquisa, setPesquisa] = React.useState('');
    const [contratos, setContratos] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [mensagem, setMensagem] = React.useState('');
    const [mensagemTipo, setMensagemTipo] = React.useState('warning');

    const [registroInicial, setRegistroInicial] = React.useState(1);
    const [registroFinal, setRegistroFinal] = React.useState(20);
    const [quantidadeRegistros, setQuantidadeRegistros] = React.useState(0);

    React.useEffect(() => {     
        async function fetchInitialData() {
          setLoading(true);
          try {
            if (!listaGlobalContratos) {
              const response = await api.get(`/Contrato/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}&regInicial=${registroInicial}&itensPorPagina=999999`);
              setQuantidadeRegistros(response.data[0]?.valorFixo ?? 0);

              const response2 = await api.get(`/Contrato/parametros-consulta-paginada?nivel=${nivelUsuario}&tipo=ativos&args=status&regInicial=${registroInicial}&itensPorPagina=${itensPorPagina}`);
              setContratos(response2.data);
              setListaGlobalContratos(response2.data);
              verificarECancelarContratos(response2.data);   
            } else {
              setContratos(listaGlobalContratos);
            }
          } catch (e) {
            console.log(e);
          } finally {
              setLoading(false);
          }
        }
    
        fetchInitialData();            
    }, []);

		const getTipoPesquisa = (pesquisa) => {
			if (!pesquisa) return '';

			const onlyNumbers = /^\d+$/;
			const hasLetters = /[a-zA-Z]/;

			if (onlyNumbers.test(pesquisa)) {
				return 'ns';
			} else if (hasLetters.test(pesquisa)) {
				return 'cliente';
			}
		}
    
    const executarConsulta = React.useCallback(async (textoPesquisa) => {
        const tipo = tipoPesquisaContratos && tipoPesquisaContratos !== '' ? tipoPesquisaContratos : getTipoPesquisa(textoPesquisa);
        let response;
        if (!textoPesquisa || textoPesquisa.length === 0) {
            const pesqType = "consulta-paginada";
            const args = tipo === "ativos" || (tipo === "totais" ? "status" : textoPesquisa);
            response = await api.get(`/Contrato/${pesqType}?nivel=${nivelUsuario}&tipo=${tipo}&id=${idDistribuidor}&regInicial=${registroInicial}&itensPorPagina=${itensPorPagina}&args=${args || ''}`);
        } else {
            const totalResp = await api.get(`/Contrato/parametros-consulta-paginada?nivel=${nivelUsuario}&tipo=${tipo}&args=${textoPesquisa}&regInicial=${registroInicial}&itensPorPagina=999999`);
            setQuantidadeRegistros(totalResp.data[0]?.valorFixo ?? 0);
            response = await api.get(`/Contrato/parametros-consulta-paginada?nivel=${nivelUsuario}&tipo=${tipo}&args=${textoPesquisa}&regInicial=${registroInicial}&itensPorPagina=${itensPorPagina}`);
            setListaGlobalContratos(response.data);
        }
        setContratos(response.data);
    }, [tipoPesquisaContratos, nivelUsuario, idDistribuidor, registroInicial, itensPorPagina, setListaGlobalContratos]);

    async function pesquisarClick(event) { 
        event.preventDefault();
        try {
            const tipo = tipoPesquisaContratos && tipoPesquisaContratos !== '' ? tipoPesquisaContratos : getTipoPesquisa(pesquisa);

            if (tipo === 'ns') {
                const onlyNumbers = /^\d+$/;
                if (!pesquisa || !onlyNumbers.test(pesquisa)) {
                    setMensagemTipo('warning');
                    setMensagem('Para pesquisar por Número de Série, digite apenas números.');
                    return;
                }
            }

            if ((tipo === 'distribuidor' || tipo === 'cliente' || tipo === 'sistema') && (!pesquisa || pesquisa.trim().length === 0)) {
                setMensagemTipo('warning');
                setMensagem('Digite um termo de pesquisa para o filtro selecionado.');
                return;
            }

            if (tipo === 'cancelados') {
                setPesquisa('');
            }
            setLoading(true);
            await executarConsulta(pesquisa);
            setPesquisa('');
        } catch (error) {
            setMensagemTipo('danger');
            setMensagem('Não foi possível realizar a pesquisa. Verifique os dados e tente novamente.');
            setPesquisa('');
            if (typeof handleTipoPesquisaContratosChange === 'function') {
                handleTipoPesquisaContratosChange('');
            }
        } finally {
            setLoading(false);
        }
    }  

    function viewContrato(contrato) {
        navigate(`/viewcontrato/${contrato.id}`);
    }

    if (loading) return <Loading />

    return (
       <section>                                
             <HeaderContratos titulo={"Contratos"} 
                pesquisa={pesquisa} setPesquisa={setPesquisa}
                pesquisarClick={pesquisarClick}
            />
            <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant={mensagemTipo} />

            <Table striped hover responsive>
                <thead className={styles.thead}>
                    <tr className={styles.trHead}>
                            <th className={styles.th}>Revenda</th>
                            <th className={styles.th}>Cliente</th>                          
                            <th className={styles.th}>Sistema</th>                        
                            <th className={styles.th}>Nr.Serie</th>
                            <th className={styles.th}>Início</th>
                            <th className={styles.th}>Final</th>
                            <th className={styles.th}>Valor (R$)</th>
                            <th className={styles.th}>Tipo</th>
                            <th className={styles.th}>Status</th>
                    </tr>
                </thead>
                {tipoPesquisaContratos !== "totais" &&
                    <tbody className={styles.tbody}>
                    {contratos.map(contrato => 
                        <tr key={contrato.id} className={styles.trBody}>                                     
                            <TableItemName title={contrato?.distribuidor?.nomeFantasia} />
                            <TableItemName title={contrato?.cliente?.razaoSocial} />
                            
                            <td className={styles.td}>{contrato.sistema}</td>
                            <td className={styles.td}>{contrato.numeroSerie}</td>  
                            <td className={styles.td}> 
                                {contrato.dataAtivacao.substring(8,10)}/   
                                {contrato.dataAtivacao.substring(5,7)}/   
                                {contrato.dataAtivacao.substring(0,4)}                               
                                
                            </td>
                            {contrato.dataCancelamento ?
                                <td className={styles.td}>
                                    {contrato.dataCancelamento.substring(8,10)}/ 
                                    {contrato.dataCancelamento.substring(5,7)}/   
                                    {contrato.dataCancelamento.substring(0,4)}    
                                </td>
                            : <td> * * * * * * </td>  
                            }
                            <td>{contrato.valor.toFixed(2)}</td>  

                            {contrato.tipoContrato === 0 && <td className={styles.td}>Manut.</td>}
                            {contrato.tipoContrato === 1 && <td className={styles.td} style={{color: "darkcyan"}}>Locação</td>}
                            {contrato.tipoContrato === 2 && <td className={styles.td} style={{color: "blueviolet"}} >Saas</td>}

                            {contrato.statusContrato === 1 ?
                                <td className={styles.td} style={{backgroundColor: "palegreen"}}>Ativo</td>
                            : ( contrato.statusContrato === 0 ? 
                              <td className={styles.td} style={{backgroundColor: "tomato"}}>Cancelado</td>
                            : <td className={styles.td} style={{backgroundColor: "lavender"}}>Baixado</td>
                            )
                            }

                            <td style={{display: 'flex'}}>
                                                                                       

                                <span> </span>                     
                                <OverlayTrigger   overlay={
                                <Tooltip id="btn-view-pedido">Visualizar Contrato</Tooltip> }>                              
                                    <Button onClick={() => viewContrato(contrato)}                                       
                                            variant="outline-success">
                                            <CardText size={18}/>
                                    </Button>                                       
                                </OverlayTrigger>                                          

                                <span> </span>                                        
                            </td>                        

                        </tr>
                    )}
                </tbody>
            }

            <tfoot>
                <Paginacao
                    setRegistroFinal={setRegistroFinal}
                    setRegistroInicial={setRegistroInicial}
                    setRegistrosData={setContratos} 
                    registroInicial={registroInicial}     
                    registroFinal={registroFinal}                                                                
                    quantidadeRegistros={quantidadeRegistros}
                    itensPorPagina={itensPorPagina} 
                    urlPesquisa={`/Contrato/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}`}
                />
            </tfoot>                    
            </Table>

       </section>
    )
}

export default ContratosIndex;